import { useContext } from 'react';
import { AlertDialogContext } from '../context/AlertDialogContext';

export function useAlertDialog() {
  return useContext(AlertDialogContext);
}
